<div class="tp-page tp-page--compact levels-container">
  <section class="tp-card tp-card--flush">
    <tp-page-header variant="toolbar" title="Niveles"
    [subtitle]="levels.length + (levels.length === 1 ? ' nivel' : ' niveles')">
    <button mat-flat-button actions id="addLevel" type="button" (click)="openModal()">
      <mat-icon>add</mat-icon>
      Agregar nivel
    </button>
    </tp-page-header>
    <ul class="sa-list">
      @for (level of levels; track level) {
        <li class="sa-item">
          <div class="sa-item__body">
            <p class="sa-item__title">{{ level.name }}</p>
            <p class="sa-item__meta">
              <span>Puntos: {{ level.requiredPoints }}</span>
              @if (!level.isVisible) {
                <span class="tp-badge tp-badge--neutral">Deshabilitado</span>
              }
            </p>
          </div>
          <app-icon-menu-button [menu]="menu" label="Más opciones"></app-icon-menu-button>
          <mat-menu #menu="matMenu">
            @if(level.isVisible){
              <button id="visibleButton" mat-menu-item (click)="enableDisableLevel(level)">Deshabilitar</button>
            } @else {
              <button id="visibleButton" mat-menu-item (click)="enableDisableLevel(level)">Habilitar</button>
            }
            <button id="editButton" mat-menu-item (click)="openModal(level)">Editar</button>
            <button id="deleteButton" mat-menu-item (click)="deleteLevel(level.id)">Eliminar</button>
          </mat-menu>
        </li>
      } @empty {
        <li>
          <tp-empty-state
            icon="military_tech"
            title="Todavía no hay niveles"
            message="Agregá el primer nivel con el botón de arriba."
          ></tp-empty-state>
        </li>
      }
    </ul>
  </section>

  <!-- Panel de alta / edición de nivel -->
  <div
    class="level-modal-container d-flex align-items-center justify-content-center w-100"
    [ngClass]="{ expanded: showLevelModal }"
  >
    @if (showLevelModal) {
      <div class="modal-container w-100">
        <app-level-modal
          [selectedlevel]="selectedLevelToEdit"
          (closeModal)="backToLevels()"
          (reloadPage)="ngOnInit()"
        ></app-level-modal>
      </div>
    }
  </div>
</div>
